export default __webpack_public_path__ + "static/media/logo-us-pink.a1e211ff.svg";